import messageService from "../message/messageService";

const OnlyEnterNumber = (e: any) => {
  if (
    [46, 8, 9, 27, 13, 37, 38, 39, 40].indexOf(e.keyCode) !== -1 ||
    (e.ctrlKey === true && [65, 67, 86, 88].indexOf(e.keyCode) !== -1) ||
    (e.keyCode >= 35 && e.keyCode <= 39)
  ) {
    return;
  }
  if (
    (e.shiftKey || e.keyCode < 48 || e.keyCode > 57) &&
    (e.keyCode < 96 || e.keyCode > 105)
  ) {
    e.preventDefault();
  }
};

const NoEnterspace = (e: React.KeyboardEvent<HTMLInputElement>) => {
  if (e.key === " " && (e.target as HTMLInputElement).value.length === 0) {
    e.preventDefault();
  }
};

const OnlyEnterNumbere = (e: React.KeyboardEvent<HTMLInputElement>) => {
  if (
    [46, 8, 9, 27, 13, 37, 38, 39, 40].indexOf(e.keyCode) !== -1 ||
    (e.ctrlKey === true && [65, 67, 86, 88].indexOf(e.keyCode) !== -1) ||
    (e.keyCode >= 35 && e.keyCode <= 39)
  ) {
    return;
  }

  if (
    !(
      (e.keyCode >= 65 && e.keyCode <= 90) ||
      (e.keyCode >= 97 && e.keyCode <= 122)
    )
  ) {
    e.preventDefault();
  }
};

const showAPiError_mesage = (errorMeassge: any) => {
  console.log(errorMeassge, "showAPiError_mesageshowAPiError_mesage");
  const messageServices = messageService();

  messageServices.toast("error", errorMeassge);
};

const validateEmail = (email: any) => {
  const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return regex.test(email);
};

const validatePhoneNumber = (phoneNumber: any) => {
  const regex =
    /^(?:\+?\d{1,3}[-.\s]?)?(?:\(?\d{3}\)?[-.\s]?)?\d{3}[-.\s]?\d{4}$/;
  return regex.test(phoneNumber);
};

function isEmptyString(value: unknown): boolean {
  return typeof value === 'string' && value.trim() === '';
}


const handleDropdownChange = (
  name: string,
  value: any,
  setFormData: React.Dispatch<React.SetStateAction<any>>,
  setError: React.Dispatch<React.SetStateAction<any>>
) => {
  const path = name.split(".");
  setFormData((prevState: any) => {
    const newState = { ...prevState };
    let currentLevel = newState;
    for (let i = 0; i < path.length - 1; i++) {
      currentLevel = currentLevel[path[i]];
    }
    currentLevel[path[path.length - 1]] = value;
    return newState;
  });

  setError((prevError: any) => {
    const newError = { ...prevError };
    let currentLevel = newError;
    for (let i = 0; i < path.length - 1; i++) {
      if (!currentLevel[path[i]]) {
        currentLevel[path[i]] = {};
      }
      currentLevel = currentLevel[path[i]];
    }
    currentLevel[path[path.length - 1]] = "";
    return newError;
  });
};

export {
  OnlyEnterNumber,
  NoEnterspace,
  OnlyEnterNumbere,
  showAPiError_mesage,
  validateEmail,
  validatePhoneNumber,
  handleDropdownChange,
  isEmptyString
};
